import { createApiRef } from "@backstage/core";
import { DiscoveryApi, IdentityApi } from "@backstage/core-plugin-api";
import axios from "axios";

export const githubApiRef = createApiRef<GithubApi>({
  id: "plugin.github-api.service",
  description: "Used by plugins to make requests to Github",
});

type Options = {
  discoveryApi: DiscoveryApi;
  identityApi: IdentityApi;
};

export class GithubApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly identityApi: IdentityApi;

  constructor(options: Options) {
    this.discoveryApi = options.discoveryApi;
    this.identityApi = options.identityApi;
  }

  /** Retrieve the primary URL  */
  private async getUrl(): Promise<string> {
    return await this.discoveryApi.getBaseUrl("github-api");
  }

  public async getCommitsByUser(handle: string) {
    const { token } = await this.identityApi.getCredentials();
    const resp = await axios.get(
      `${await this.getUrl()}/getCommitsByUser?handle=${handle}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp.data;
  }

  public async getPullRequestsByUser(handle: string) {
    const { token } = await this.identityApi.getCredentials();
    const resp = await axios.get(
      `${await this.getUrl()}/getPullRequestsByUser?handle=${handle}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp.data;
  }

  public async repoHasTechdocs(repo: string) {
    const { token } = await this.identityApi.getCredentials();
    const resp = await axios.get(
      `${await this.getUrl()}/repoHasTechDocs?repo=${repo}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );
    return resp.data;
  }
}
